
/* injects from baggage-loader */


import dialogBallonsTpl from './dialog-ballons.html';
import DialogBallonsController from './dialog-ballons.controller';

export default class DialogBallonsComponent {
    constructor() {
        this.templateUrl = dialogBallonsTpl;
        this.controller = DialogBallonsController;
        this.bindings = {
            dialogs: "=",
            position: "=",
            thumb: "=",
            onClose: "&",
            visible: "=",
            backdrop: "=",
            static: "=",
            autoclose: "=",
            intro: "="
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/dialog-ballons/dialog-ballons.component.js